<app-header-invitation-b2b></app-header-invitation-b2b>
<div class="container">
<ng-content>
</ng-content>
</div>

<signup-footer></signup-footer>
